module.exports = __webpack_public_path__ + "static/media/244-130Z2154Z5.efd00983.jpg";